import { z } from 'zod';

import { normalizeRange, resolveRangeFrom } from '@/features/stats/range';

export const AUDIENCE_METRICS = [
  { value: 'followers', label: '팔로워' },
  { value: 'subscribers', label: '구독자' },
  { value: 'new-follows', label: '신규 팔로우' },
  { value: 'new-subscriptions', label: '신규 구독' },
  { value: 'churn', label: '해지·만료' },
] as const;

export type AudienceMetric = (typeof AUDIENCE_METRICS)[number]['value'];

/** 주소창 상태 — 잘못된 값은 기본값으로 바꿔 화면이 깨지지 않게 한다 */
export const audienceSearchSchema = z.object({
  unit: z.enum(['day', 'week', 'month']).default('day').catch('day'),
  range: z.string().optional().catch(undefined),
  metric: z
    .enum(['followers', 'subscribers', 'new-follows', 'new-subscriptions', 'churn'])
    .default('followers')
    .catch('followers'),
  sort: z.enum(['coin', 'recent']).default('coin').catch('coin'),
  page: z.coerce.number().int().min(1).default(1).catch(1),
});

export type AudienceSearch = z.infer<typeof audienceSearchSchema>;

/** 검색 조건 → API 추이 조건 */
export function audienceTrendParams(search: Pick<AudienceSearch, 'unit' | 'range'>) {
  const range = normalizeRange(search.unit, search.range);
  return { unit: search.unit, from: resolveRangeFrom(search.unit, range), range };
}
